import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/outline';

export const Chevron: React.FC = () => <ChevronDownIcon className="flex-shrink-0 w-5 h-5 text-gray-50" />;
